import React from 'react';
import PropTypes from 'prop-types';
import { paper } from '@constants/mui-theme';
import Tab from '@shared/vertical-scroll-tabs/tab';
import './vertical-scroll-tabs.scss';

const Tabs = ({ dataType, tabs }) => (
  <div styleName="tabs-container" style={{ ...paper, boxShadow: 'none' }}>
    {tabs?.map(tab => <Tab key={tab.id} {...tab} dataType={dataType} />)}
  </div>
);

Tabs.propTypes = {
  dataType: PropTypes.string,
  tabs: PropTypes.array
};

export default Tabs;
